// CHANGED: default zoom was 90% (zoom button hidden from UI); now 100% — software zoom disabled.
// export const DEFAULT_APP_ZOOM_PERCENT = 90;
export const DEFAULT_APP_ZOOM_PERCENT = 100;
export const MIN_APP_ZOOM_PERCENT = 60;
export const MAX_APP_ZOOM_PERCENT = 100;
export const LOGIN_APP_ZOOM_PERCENT = 100;
export const APP_ZOOM_MODE_VISUAL = 'visual';
export const APP_ZOOM_MODE_COMPACT = 'compact';

const LEGACY_ZOOM_KEY = 'app_zoom_percent';
const LEGACY_MODE_KEY = 'app_zoom_mode';

export const getZoomPercentStorageKey = (userId) => `app_zoom_percent_${userId}`;
export const getZoomModeStorageKey = (userId) => `app_zoom_mode_${userId}`;

export const getLoggedInUserId = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.user_id != null ? String(parsed.user_id) : null;
  } catch {
    return null;
  }
};

export const clampZoomPercent = (value, fallback = DEFAULT_APP_ZOOM_PERCENT) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.max(MIN_APP_ZOOM_PERCENT, Math.min(MAX_APP_ZOOM_PERCENT, Math.round(parsed)));
};

export const normalizeZoomMode = (value) =>
  (value === APP_ZOOM_MODE_COMPACT ? APP_ZOOM_MODE_COMPACT : APP_ZOOM_MODE_VISUAL);

export const getStoredZoomForUser = (userId) => {
  if (!userId) {
    return {
      zoomPercent: LOGIN_APP_ZOOM_PERCENT,
      zoomMode: APP_ZOOM_MODE_VISUAL
    };
  }

  const zoomKey = getZoomPercentStorageKey(userId);
  const modeKey = getZoomModeStorageKey(userId);
  let zoomRaw = localStorage.getItem(zoomKey);
  const modeRaw = localStorage.getItem(modeKey);

  if (zoomRaw === null) {
    const legacyZoom = localStorage.getItem(LEGACY_ZOOM_KEY);
    if (legacyZoom !== null) {
      zoomRaw = legacyZoom;
      localStorage.setItem(zoomKey, legacyZoom);
    }
  }

  if (modeRaw === null) {
    const legacyMode = localStorage.getItem(LEGACY_MODE_KEY);
    if (legacyMode === APP_ZOOM_MODE_VISUAL || legacyMode === APP_ZOOM_MODE_COMPACT) {
      localStorage.setItem(modeKey, legacyMode);
    }
  }

  return {
    zoomPercent: zoomRaw === null ? DEFAULT_APP_ZOOM_PERCENT : clampZoomPercent(zoomRaw),
    zoomMode: normalizeZoomMode(localStorage.getItem(modeKey))
  };
};

export const setStoredZoomForUser = (userId, zoomPercent, zoomMode) => {
  if (!userId) return;

  localStorage.setItem(
    getZoomPercentStorageKey(userId),
    String(clampZoomPercent(zoomPercent))
  );
  localStorage.setItem(
    getZoomModeStorageKey(userId),
    normalizeZoomMode(zoomMode)
  );
};

export const clearLegacyZoomStorage = () => {
  localStorage.removeItem(LEGACY_ZOOM_KEY);
  localStorage.removeItem(LEGACY_MODE_KEY);
};
